<template>
  <layout-sale :top="0" :role="1">
    <!-- 公司信息 -->
    <div class="company">
      <van-icon name="location-o" />
      <span>{{ companyInfo.name }}</span>
    </div>
    <!-- 部门信息 -->
    <div class="department">
      <van-icon name="wap-home-o" />
      <span>{{ deptInfo.name }}</span>
    </div>
    <!-- <div class="page" ref="page">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>1</van-swipe-item>
        <van-swipe-item>2</van-swipe-item>
      </van-swipe>
    </div> -->
    <Map dim="2">
      <!-- <span class="tip" @click="$router.push('/risk')">风险提示</span> -->
    </Map>
    <div class="row-btn">
      <van-row gutter="16">
        <van-col span="12">
          <van-button block plain type="primary" to="/delivery">
            送货
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button block plain type="primary" to="/salesGroupOrder"
            >订单</van-button
          >
        </van-col>
      </van-row>
    </div>
  </layout-sale>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getDepartInfo } from '@/api/salehome'
import { getDetail } from '@/api/modifyCompany'
// import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useGetData } from '@/hooks/useGetData'

export default {
  name: 'SalesHome',
  setup() {
    // 获取公司信息
    const companyInfo = ref([])
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const departId = computed(() => store.state.roleInfo.departId)
    const getCompanyInfo = useGetData(getDetail, data => {
      companyInfo.value = data
    })
    getCompanyInfo(companyId.value)
    const deptInfo = ref({}) // 销售部信息
    useGetData(getDepartInfo, data => {
      deptInfo.value = data
    })({ deptId: departId.value })
    return {
      companyInfo,
      deptInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.company {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 16px;
}
.department {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding: 16px;
}
.personnel-container {
  margin: 0 16px;
  li {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 10px 16px;
    border-radius: 3px;
    margin-bottom: 16px;
    font-size: 14px;
    color: #666;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  }
  &__name {
    width: 80px;
  }
  &__phone {
    font-weight: 600;
    margin-left: 5px;
    flex: 1;
    margin-right: 10px;
  }
  &__icon {
    margin-right: 5px;
  }
}
.row-btn {
  margin: 16px;
}
.btn {
  margin: 16px;
  button {
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
  }
}
.page {
  /*height: 100vh;*/
  background-color: #ededed;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
}
.tip {
  background-color: red;
  padding: 10px 15px;
  font-size: 14px;
  color: #fff;
  position: absolute;
  right: 0;
}
</style>
